import React, { memo } from 'react';
import { BusinessAuthenticationProvider } from './context/BussinessAuthenticationContext';
import { AuthenticationProvider } from './context/AuthenticationContext';
import MainRouter from './routes/MainRouter';
import GetTheme from './Themes/MyTheme';
import { ThemeProvider } from '@mui/material';

function App() {
    const { theme, themeVariables } = GetTheme();

    return (
        <AuthenticationProvider>
            <BusinessAuthenticationProvider>
                <ThemeProvider theme={theme}>
                    <div style={themeVariables}>
                        <MainRouter />
                    </div>
                </ThemeProvider>
            </BusinessAuthenticationProvider>
        </AuthenticationProvider>
    );
}

export default memo(App);
